import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {getAccountPage} from 'src/openapi/admin/apis/AccountInfoApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
};

export const useGetAccountInfo = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(
        () => apiDispatch(getAccountPage({accountId})),
        [accountId, apiDispatch],
    );

    return useReadOnlyDataHook({
        getDispatchAction,
        initValue: null,
    });
};
